import { cn } from "@/lib/utils";
import { textVariants } from "@/src/components/Text/Text";
import { Card } from "@/src/components/shad/card";
import { tradeType } from "../DirectTrade";
import { UseFormSetValue } from "react-hook-form";
import { Check, ChevronRight, XIcon } from "lucide-react";
import { isEmpty } from "lodash";
import { Link } from "react-router-dom";
import { useState } from "react";
import { Modal } from "@/src/components/Modal/Modal";
import { Button } from "@/src/components/Button/Button";
import walletIm from "@assets/wallet.svg";
import AddPayments from "../../PaymentMethods/components/AddPayments";
import { useTranslation } from "react-i18next";

interface Props {
  paymentMethods: ComponentsPaymentMethod[] | undefined;
  setValue: UseFormSetValue<tradeType>;
  selectedPayment: number | undefined;
}

const BuyPayments = ({ paymentMethods, setValue, selectedPayment }: Props) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [show, setShow] = useState(false);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<
    ComponentsPaymentMethod | undefined
  >();

  const removePaymentMethod = () => {
    // const newPaymentMethods = paymentMethods?.filter((item) => item?.id !== id);
    setSelectedPaymentMethod(undefined);
    setValue("payment", undefined);
  };
  return (
    <Card className="grid p-4">
      <span className={textVariants()}>
        {t("app.buysell.paymentMethods.header")}
      </span>

      <div className="grid md:grid-cols-2 gap-4 mt-3">
        <Card
          onClick={() => setShow(true)}
          className={"p-3 flex items-center gap-2 cursor-pointer"}
        >
          <div className="rounded-full bg-[#809AF7] p-1">
            <img src={walletIm} className="h-5 w-5 rounded-full" alt="icon" />
          </div>
          <div className="grid gap-1">
            <span className={textVariants()}>
              {t("app.buysell.paymentMethods.addNewPayment.label")}
            </span>
            <span className={textVariants({ size: "xs" })}>
              {t("app.buysell.paymentMethods.addNewPayment.desc")}
            </span>
          </div>
        </Card>
        <Card
          onClick={() => setOpen(true)}
          className={cn(
            "flex justify-between items-center p-2 cursor-pointer  h-full"
          )}
        >
          <div className="p-2 flex items-center gap-2 cursor-pointer">
            <div className="grid gap-1">
              <span className={textVariants({ font: "semibold" })}>
                {t("app.buysell.paymentMethods.selectPayment.label")}
              </span>
            </div>
          </div>
          <ChevronRight className="h-6 w-6 dark:text-white" />
        </Card>
      </div>
      <div className="grid lg:grid-cols-3 md:grid-cols-2 mt-5">
        {selectedPaymentMethod && (
          <Card className={cn("flex justify-between items-center px-2")}>
            <div className="p-2 flex items-center gap-2 cursor-pointer">
              <div>
                <img
                  src={selectedPaymentMethod?.service__image}
                  className="h-6 w-6 rounded-full"
                  alt={selectedPaymentMethod?.service__name}
                />
              </div>
              <div className="grid gap-1">
                <span className={textVariants({ font: "semibold" })}>
                  {selectedPaymentMethod?.service__name}
                </span>
                <span className={textVariants({ size: "xs" })}>
                  {selectedPaymentMethod?.account_number}
                </span>
              </div>
            </div>
            <div
              onClick={() => removePaymentMethod()}
              className="h-5 w-5 rounded-full bg-gray-50 dark:bg-grey-500 flex items-center justify-center my-2 cursor-pointer"
            >
              <XIcon className="h-4 w-4 text-gray-500" />
            </div>
          </Card>
        )}
      </div>

      <Modal
        open={show}
        setOpen={setShow}
        setter="state"
        title={t("app.buysell.paymentMethods.addNewPayment.modal.title")}
      >
        <AddPayments allow_debit />
      </Modal>

      <Modal
        title={t("app.buysell.paymentMethods.selectPayment.label")}
        open={open}
        setOpen={setOpen}
        setter="state"
        footer={
          <Button onClick={() => setOpen(false)}>
            {t("app.buysell.paymentMethods.selectPayment.modal.continueButton")}
          </Button>
        }
      >
        <div>
          {/* <span className={textVariants()}>Payment Methods</span> */}
          {!isEmpty(paymentMethods) ? (
            <div className="mt-3 grid xl:grid-cols-2  gap-4">
              {paymentMethods
                ?.filter(
                  (item) =>
                    item?.payment_type === "debit" ||
                    item?.payment_type === "both"
                )
                ?.map((method) => (
                  <Card
                    key={method?.id}
                    onClick={() => [
                      setValue("payment", method?.id),
                      setSelectedPaymentMethod(method),
                    ]}
                    className={cn(
                      "flex justify-between items-center px-2",
                      selectedPayment === method?.id &&
                        "border border-blue-500 dark:border-blue-200"
                    )}
                  >
                    <div className="p-2 flex items-center gap-2 cursor-pointer">
                      <div>
                        <img
                          src={method?.service__image}
                          className="h-6 w-6 rounded-full"
                          alt={method?.service__name}
                        />
                      </div>
                      <div className="grid gap-1">
                        <span className={textVariants({ font: "semibold" })}>
                          {method?.service__name}
                        </span>
                        <span className={textVariants({ size: "xs" })}>
                          {method?.account_number}
                        </span>
                      </div>
                    </div>
                    <div className="h-5 w-5 rounded-full bg-gray-100 dark:bg-grey-500 flex items-center justify-center">
                      {selectedPayment === method?.id && (
                        <Check className="h-4 w-4 text-blue-500 dark:text-blue-200" />
                      )}
                    </div>
                  </Card>
                ))}
            </div>
          ) : (
            <div className="py-4">
              <span
                className={cn(textVariants({ size: "sm", variant: "desc" }))}
              >
                You have not added any payment methods yet. Click{" "}
                <Link
                  to={"/app/payments?add_payment=open"}
                  className={cn(
                    textVariants({ variant: "link", size: "sm" }),
                    "cursor-pointer"
                  )}
                >
                  here
                </Link>{" "}
                to add
              </span>
            </div>
          )}
        </div>
      </Modal>
    </Card>
  );
};

export default BuyPayments;
